<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
      top="2vh"
      title="Thêm mới Plus"
    >
      <el-form
        label-width="140px"
        :model="formAllTabEmployee"
        label-position="left"
        :rules="rules"
        ref="formAllTabEmployee"
      >
        <el-tabs type="card" v-model="activeTabName" @tab-click="handleClick">
          <el-tab-pane label="Thông tin" name="infoTab">
            <div class="common-info-tab">
              <el-row :gutter="24">
                <!-- Column 1: Profile Summary & QR -->
                <el-col :span="6">
                  <div class="profile-sidebar-card">
                    <!-- Avatar Area -->
                    <div class="profile-avatar-wrap">
                      <el-image
                          v-if="imageUrlPreview"
                          class="profile-avatar"
                          :src="imageUrlPreview"
                          fit="cover"
                      ></el-image>
                      
                      <!-- Hidden upload trigger -->
                      <el-upload
                          :show-file-list="false"
                          :on-change="toggleUpload"
                          :on-remove="handleRemove"
                          :auto-upload="false"
                          style="display: none;"
                          ref="upload"
                          action=""
                      >
                      </el-upload>
                      
                      <!-- Click-to-add Area if empty -->
                      <div 
                          v-if="!imageUrlPreview"
                          class="avatar-trigger-area"
                          @click="triggerAvatarUpload"
                      >
                        <i class="el-icon-plus"></i>
                        <span>Thêm ảnh đại diện</span>
                      </div>
                      
                      <!-- Hover edit/delete overlay if image exists -->
                      <div 
                          v-else
                          class="avatar-actions-overlay"
                      >
                        <button type="button" class="avatar-action-btn edit-btn" @click="triggerAvatarUpload" title="Thay đổi ảnh">
                          <i class="el-icon-edit-outline"></i>
                        </button>
                        <button type="button" class="avatar-action-btn delete-btn" @click="handleRemove" title="Xóa ảnh">
                          <i class="el-icon-delete"></i>
                        </button>
                      </div>
                    </div>

                    <!-- QR Bank Card Area -->
                    <div class="qr-bank-section">
                      <div class="section-divider">Ảnh QR ngân hàng</div>
                      <div class="qr-container-wrap">
                        <el-image
                            v-if="qrUrlPreview"
                            class="qr-bank-image"
                            :src="qrUrlPreview"
                            fit="contain"
                        ></el-image>
                        
                        <!-- Hidden upload trigger for QR -->
                        <el-upload
                            :show-file-list="false"
                            :on-change="toggleUploadQr"
                            :on-remove="handleRemoveQr"
                            :auto-upload="false"
                            style="display: none;"
                            ref="uploadQr"
                            action=""
                        >
                        </el-upload>

                        <!-- Click-to-add Area if empty -->
                        <div 
                            v-if="!qrUrlPreview"
                            class="qr-trigger-area"
                            @click="triggerQrUpload"
                        >
                          <i class="el-icon-plus"></i>
                          <span>Thêm QR</span>
                        </div>
                        
                        <!-- Hover edit/delete overlay if QR exists -->
                        <div 
                            v-else
                            class="qr-actions-overlay"
                        >
                          <button type="button" class="avatar-action-btn edit-btn" @click="triggerQrUpload" title="Thay đổi QR">
                            <i class="el-icon-edit-outline"></i>
                          </button>
                          <button type="button" class="avatar-action-btn delete-btn" @click="handleRemoveQr" title="Xóa QR">
                            <i class="el-icon-delete"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>

                <!-- Column 2: Personal Information Grid -->
                <el-col :span="9">
                  <div class="info-section-card">
                    <div class="card-inner-title"><i class="el-icon-user"></i> Thông tin nhân sự</div>
                    
                    <el-form-item label="Họ tên" prop="createEmployeeMainInfoRequest.fullName">
                      <el-input
                          v-model="formAllTabEmployee.createEmployeeMainInfoRequest.fullName"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Số điện thoại" prop="createEmployeeMainInfoRequest.phone">
                          <el-input
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.phone"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="createEmployeeMainInfoRequest.gender" label="Giới tính">
                          <el-radio-group
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.gender"
                              class="gender-radio-group"
                          >
                            <el-radio-button label="Nam">Nam</el-radio-button>
                            <el-radio-button label="Nữ">Nữ</el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày sinh" prop="createEmployeeMainInfoRequest.birthday">
                          <el-date-picker
                              :clearable="false"
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.birthday"
                              format="dd-MM-yyyy"
                              :picker-options="pickerOptions"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày sinh"
                              style="width: 100%"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Dân tộc" prop="createEmployeeMainInfoRequest.ethnic">
                          <el-input
                              clearable
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.ethnic"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Email" prop="createEmployeeMainInfoRequest.email">
                      <el-input
                          v-model="formAllTabEmployee.createEmployeeMainInfoRequest.email"
                      ></el-input>
                    </el-form-item>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item prop="createEmployeeMainInfoRequest.cmnd">
                          <span slot="label">
                            Số định danh
                            <el-tooltip class="item" effect="dark" content="Số định danh của nhân sự" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </span>
                          <el-input
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.cmnd"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày cấp" prop="createEmployeeMainInfoRequest.cmndDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.cmndDate"
                              style="width: 100%"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Chọn ngày cấp"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <div class="section-divider" style="margin: 16px 0 12px;">Tài khoản nhận lương</div>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngân hàng">
                          <el-input
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.nameBank"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Số tài khoản">
                          <el-input
                              type="number"
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.bankAccountNumber"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>

                <!-- Column 3: Work & Other Details -->
                <el-col :span="9">
                  <div class="info-section-card parent-card">
                    <div class="card-inner-title"><i class="el-icon-suitcase-1"></i> Thông tin công việc & Hôn nhân</div>
                    
                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày vào" prop="createEmployeeMainInfoRequest.startDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.startDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày vào"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Ngày ký hợp đồng" prop="createEmployeeMainInfoRequest.contractDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.contractDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Chọn ngày"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Ngày hết hạn" prop="createEmployeeMainInfoRequest.endDate">
                          <el-date-picker
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.endDate"
                              type="date"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              style="width: 100%"
                              placeholder="Ngày hết hạn"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Trình độ" prop="createEmployeeMainInfoRequest.educationLevel">
                          <el-input
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.educationLevel"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="12">
                        <el-form-item label="Đối tượng" prop="createEmployeeMainInfoRequest.idAccountTypeList">
                          <el-select
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.idAccountTypeList"
                              multiple
                              placeholder="Chọn đối tượng"
                              clearable
                              style="width: 100%"
                              filterable
                          >
                            <el-option
                                v-for="item in accountTypeList"
                                :key="item.id"
                                :value="item.id"
                                :label="item.name"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Hôn nhân" prop="createEmployeeMainInfoRequest.marriedStatus">
                          <el-select
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.marriedStatus"
                              filterable
                              clearable
                              style="width: 100%"
                          >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="16">
                      <el-col :span="24">
                        <el-form-item label="Số con" prop="createEmployeeMainInfoRequest.numberChildren">
                          <el-input
                              v-model="formAllTabEmployee.createEmployeeMainInfoRequest.numberChildren"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="Địa chỉ thường trú" prop="createEmployeeMainInfoRequest.permanentAddress">
                      <el-input
                          v-model="formAllTabEmployee.createEmployeeMainInfoRequest.permanentAddress"
                      ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="Chỗ ở hiện tại" prop="createEmployeeMainInfoRequest.address">
                      <el-input
                          v-model="formAllTabEmployee.createEmployeeMainInfoRequest.address"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="Ghi chú" prop="createEmployeeMainInfoRequest.note">
                      <el-input
                          v-model="formAllTabEmployee.createEmployeeMainInfoRequest.note"
                          type="textarea"
                          :rows="1"
                          style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <!-- app pluss -->
          <el-tab-pane name="Notify" label="App Plus">
            <!-- table 1 -->
            <el-table
              class="table-icon-1"
              border
              :data="plusIconAppCreate.plusIconCreate1"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
            >
              <el-table-column width="50" type="index" label="STT" align="center"></el-table-column>
              <el-table-column prop="iconName" min-width="130" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
              <template slot-scope="scope">
                <el-checkbox
                  v-if="scope.row.rootLockStatus"
                  v-model="scope.row.status"
                ></el-checkbox>
                <el-checkbox v-else disabled></el-checkbox>
              </template>
              </el-table-column>
            </el-table>

            <!-- table 2 -->
            <el-table
              class="table-icon-2"
              border
              :data="plusIconAppCreate.plusIconCreate2"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
            >
              <el-table-column width="50" type="index" label="STT" align="center"></el-table-column>
              <el-table-column prop="iconName" min-width="130" label="Chức năng"></el-table-column>
              <el-table-column label="Hiển thị" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.statusShow"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Mở khóa" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-if="scope.row.rootLockStatus"
                    v-model="scope.row.status"
                  ></el-checkbox>
                  <el-checkbox v-else disabled></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div class="tab-infor-button">
        <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('formAllTabEmployee')"
        >
          <i class="el-icon-circle-close" />
          <span>Đóng</span>
        </el-button>
        <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm('formAllTabEmployee')"
        >
          <i class="el-icon-circle-check" />
          <span>Lưu</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
import SupperPlusService from "@/services/SupperPlusService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      activeTabName: "infoTab",
      fileList: [],
      fileQrList: [],
      fileAvatar: "",
      fileQrBank: null,
      showUpload: true,
      showUploadQr: true,
      dialogImageUrl: "",
      imageUrlPreview: "",
      qrUrlPreview: "",
      dialogVisible1: false,
      disabled: false,

      accountTypeList: [],
      subjectClass: "",
      subjectInClass: [],
      disabledIsMaster: false,
      isMasterAccountType: true,
      employeeSavedSuccess: {},
      listSubject: [],
      listIdSubject: [],
      kkk: [],
      idClassCheck: "",

      teacherIconAppCreate: {
        teacherIconCreate1: [],
        teacherIconCreate2: [],
      },
      plusIconAppCreate: {
        plusIconCreate1: [],
        plusIconCreate2: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      emloyeeCode: "ABCDE-123456",
      employeeStatusRadio: "Đang làm",
      value: "",
      checkIsClass: true,
      radiogender: "",
      options: [
        {
          value: "Độc thân",
          label: "Độc thân",
        },
        {
          value: "Đã kết hôn",
          label: "Đã kết hôn",
        },
      ],
      loadingButton: false,
      formAllTabEmployee: {
        createEmployeeMainInfoRequest: {
          idAccountTypeList: "",
          fullName: "",
          birthday: "",
          address: "",
          gender: "",
          email: "",
          phone: "",
          cmnd: "",
          cmndDate: "",
          employeeStatus: "Đang làm",
          code: "",
          permanentAddress: "",
          marriedStatus: "",
          numberChildren: "",
          educationLevel: "",
          startDate: "",
          contractDate: "",
          endDate: "",
          note: "",
          appType: "plus",
          avatar: "",
          ethnic: "",
          bankAccountNumber: "",
          nameBank: "",
          imgBank: "",
        },
        tabDepartmentInEmployee: [],
        tabDepartmentRequestList: [],
        tabProfessionalInEmployee: [],
        tabProfessionalRequestList: [],
        appIconTeacherRequestList: [],
        appIconPlusRequestList: [],
        notifyAppIconPlusRequestList: [],
      },

      rules: {
        createEmployeeMainInfoRequest: {
          fullName: [
            {
              required: true,
              message: "Họ tên không được để trống",
              trigger: "blur",
            },
          ],
          phone: [
            {
              min: 10,
              max: 10,
              message: "Số điện thoại bao gồm 10 số",
              trigger: "change",
            },
            {
              required: true,
              message: "Số điện thoại không được để trống",
              trigger: "change",
            },
          ],
          gender: [
            {
              required: true,
              message: "Giới tính không được để trống",
              trigger: "blur",
            },
          ],
          startDate: [
            {
              required: true,
              message: "Ngày vào không được để trống",
              trigger: "blur",
            },
          ],
          birthday: [
            {
              required: true,
              message: "Ngày sinh không được để trống",
              trigger: "blur",
            },
          ],
          listAppType: [
            {
              required: true,
              message: "Bạn phải chọn ít nhất 1 ứng dụng",
              trigger: "blur",
            },
          ],
        },
      },
    };
  },
  methods: {
    selectionMultiDepartment(index, row) {
      let indexFind = this.formAllTabEmployee.tabDepartmentRequestList.indexOf(row);
      if (indexFind == -1) {
        this.formAllTabEmployee.tabDepartmentRequestList.push(row);
      } else {
        this.formAllTabEmployee.tabDepartmentRequestList.splice(indexFind, 1);
      }
      console.log(this.formAllTabEmployee.tabDepartmentRequestList);
    },

    selectMultiSubject(index, row) {
      let a = this.listSubject;
      let indexFind = this.listSubject.indexOf(row);
      if (indexFind == -1) {
        this.listSubject.push(row);
      } else {
        this.listSubject.splice(indexFind, 1);
      }
      console.log(a);
    },
    handleMultiSelectSubject() {
      if (
        this.formAllTabEmployee.subjectInClassRequestList === undefined ||
        this.formAllTabEmployee.subjectInClassRequestList.length == 0
      ) {
        let e = (this.formAllTabEmployee.subjectInClassRequestList = this.listSubject);
        console.log(e);
      } else {
        var a = this.formAllTabEmployee.subjectInClassRequestList;
      }
      console.log(a);
    },
    selectionMultiProfessional(index, row) {
      let indexFind = this.formAllTabEmployee.tabProfessionalRequestList.indexOf(row);
      if (indexFind == -1) {
        this.formAllTabEmployee.tabProfessionalRequestList.push(row);
      } else {
        this.formAllTabEmployee.tabProfessionalRequestList.splice(indexFind, 1);
      }
    },
    selectionMultiIsMaster(index, row) {
      console.log(row);
    },
    selectionMultiIsMaster1(index, row) {
      this.disabledIsMaster = true;
      console.log(row);
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    closeDialog() {
      this.activeTabName = "infoTab";
      this.$refs["formAllTabEmployee"].resetFields();
      this.$emit("dialog-close");
      this.handleRemove();
      this.handleRemoveQr();
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.activeTabName = "infoTab";
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.handleRemove();
      this.handleRemoveQr();
    },
    resetFormData() {
      location.reload();
    },
    triggerAvatarUpload() {
      if (this.$refs.upload) {
        this.$refs.upload.$el.querySelector('.el-upload__input').click();
      }
    },
    triggerQrUpload() {
      if (this.$refs.uploadQr) {
        this.$refs.uploadQr.$el.querySelector('.el-upload__input').click();
      }
    },
    handleRemove() {
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.showUpload = true;
      this.formAllTabEmployee.createEmployeeMainInfoRequest.avatar = null;
      this.imageUrlPreview = "";
    },
    handleRemoveQr() {
      if (this.$refs.uploadQr) {
        this.$refs.uploadQr.clearFiles();
      }
      this.showUploadQr = true;
      this.formAllTabEmployee.createEmployeeMainInfoRequest.imgBank = null;
      this.qrUrlPreview = "";
    },
    toggleUpload(file, fileList) {
      this.showUpload = !this.showUpload;
      this.fileAvatar = file.raw;
      this.formAllTabEmployee.createEmployeeMainInfoRequest.avatar = this.fileAvatar.name;
      this.fileList = fileList;
      this.imageUrlPreview = URL.createObjectURL(file.raw);
    },
    toggleUploadQr(file, fileList) {
      this.showUploadQr = false;
      this.fileQrBank = file.raw;
      this.formAllTabEmployee.createEmployeeMainInfoRequest.imgBank = file.name;
      this.fileQrList = fileList;
      this.qrUrlPreview = URL.createObjectURL(file.raw);
    },
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
        .then((_) => {
          console.log(_);
          done();
        })
        .catch((_) => {
          console.log(_);
        });
    },
    tabPlusIconMethod() {
      SupperPlusService.findIconPlusCreate()
        .then((resp) => {
          this.plusIconAppCreate.plusIconCreate1 =
            resp.data.data.appIconPlusResponseList1;
          this.plusIconAppCreate.plusIconCreate2 =
            resp.data.data.appIconPlusResponseList2;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          // let iconArrayTeacher1 = this.teacherIconAppCreate.teacherIconCreate1;
          // let iconArrayTeacher2 = this.teacherIconAppCreate.teacherIconCreate2;
          // let iconArrayTeacher = iconArrayTeacher1.concat(iconArrayTeacher2);
          // this.formAllTabEmployee.appIconTeacherRequestList = iconArrayTeacher;

          let iconArrayPlus1 = this.plusIconAppCreate.plusIconCreate1;
          let iconArrayPlus2 = this.plusIconAppCreate.plusIconCreate2;
          let iconArrayPlus = iconArrayPlus1.concat(iconArrayPlus2);
          this.formAllTabEmployee.appIconPlusRequestList = iconArrayPlus;

          // let iconNotifyArrayPlus1 = this.notifyPlusIconAppCreate.plusIconNotifyCreate1;
          // let iconNotifyArrayPlus2 = this.notifyPlusIconAppCreate.plusIconNotifyCreate2;
          // let iconNotifyArrayPlus = iconNotifyArrayPlus1.concat(iconNotifyArrayPlus2);
          // this.formAllTabEmployee.notifyAppIconPlusRequestList = iconNotifyArrayPlus;
          // this.formAllTabEmployee.tabDepartmentRequestList;
          // this.formAllTabEmployee.createEmployeeMainInfoRequest.appType = "plus";

          let formDatas = new FormData();
          formDatas.append("multipartFile", this.fileAvatar);

          SupperPlusService.createPlus(this.formAllTabEmployee)
            .then((response) => {
              this.employeeSavedSuccess = response.data.data;
              // if (this.formAllTabEmployee.createEmployeeMainInfoRequest.avatar != "") {
              //   this.uploadAvatarMethod(formDatas);
              // }
              this.$message({
                message: response.data.message,
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },
    // uploadAvatarMethod(formData) {
    //   EmployeeDataService.uploadAvatar(formData);
    // },
    getAllAccountType() {
      EmployeeDataService.getAccountType()
        .then((response) => {
          this.accountTypeList = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },
    handleDownload(file) {
      console.log(file);
    },
  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-button--primary {
  width: 100%;
  background: #409eff;
}
/deep/.upload-demo {
  text-align: center;
  .el-upload {
    width: 100%;
  }
}
/deep/.el-avatar {
  display: inline;
  img {
    border-radius: 5px;
    width: 100%;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}
.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}
.bg-purple {
  background: #d3dce6;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.group-radio-status {
  margin: 0 50px;
  .kids-status {
    margin-bottom: 10px;
  }
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.table-icon-1 {
  width: 32%;
  margin-left: 15%;
  display: inline-block;
}
.table-icon-2 {
  width: 32%;
  margin-right: 15%;
  float: right;
}

/* Redesigned Information Tab Style rules */
.common-info-tab {
  & > .el-row {
    display: flex;
    align-items: stretch;
  }

  /deep/ .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    
    .el-form-item__label {
      width: 100% !important;
      text-align: left;
      float: none;
      line-height: 20px;
      padding: 0 0 6px 0;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
    }
    
    .el-form-item__content {
      margin-left: 0 !important;
      line-height: normal;
    }
  }
}

.profile-sidebar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  box-sizing: border-box;
}

.profile-avatar-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  background: #f8fafc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  
  .profile-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-trigger-area {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    gap: 4px;
    transition: all 0.2s ease;

    i {
      font-size: 20px;
      font-weight: bold;
    }

    &:hover {
      background: #f1f5f9;
      color: #3b82f6;
    }
  }

  .avatar-actions-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    opacity: 0;
    transition: opacity 0.25s ease;
    z-index: 10;
  }

  &:hover .avatar-actions-overlay {
    opacity: 1;
  }

  .avatar-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    outline: none;
    background: #ffffff;
    color: #0f172a;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: scale(1.1);
    }

    &.edit-btn:hover {
      background: #3b82f6;
      color: #ffffff;
    }

    &.delete-btn:hover {
      background: #ef4444;
      color: #ffffff;
    }
  }
}

.qr-bank-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qr-container-wrap {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  
  .qr-bank-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 6px;
    box-sizing: border-box;
  }
}

.qr-trigger-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  transition: all 0.2s ease;

  i {
    font-size: 20px;
    font-weight: bold;
  }

  &:hover {
    background: #f1f5f9;
    color: #10b981;
  }
}

.qr-actions-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  opacity: 0;
  transition: opacity 0.25s ease;
  z-index: 10;
}

.qr-container-wrap:hover .qr-actions-overlay {
  opacity: 1;
}

.info-section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  margin-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}

.card-inner-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #3b82f6;
    font-size: 16px;
  }
}

.parent-card {
  .card-inner-title i {
    color: #10b981;
  }
}

.section-divider {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.gender-radio-group {
  width: 100%;
  display: flex;
  
  /deep/ .el-radio-button {
    flex: 1;
    
    .el-radio-button__inner {
      width: 100%;
      border-radius: 10px !important;
      padding: 10px 0;
      text-align: center;
      border: 1px solid #e2e8f0;
      color: #64748b;
      font-weight: 500;
    }
    
    &.is-active .el-radio-button__inner {
      background-color: #3b82f6;
      border-color: #3b82f6;
      color: #ffffff;
    }
  }
}
</style>
